import React, { ReactNode } from "react";
import { Button } from "../Button";
import { darken } from "@mui/material";

interface ISocialButton {
  onClick: () => void;
  children: ReactNode;
  borderColor?: string;
  color?: string;
  backgroundColor: string;
  icon?: ReactNode;
}

export const SocialButton: React.FC<ISocialButton> = ({
  onClick,
  children,
  borderColor,
  color,
  backgroundColor,
  icon
}) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      sx={{
        borderColor,
        color,
        backgroundColor,
        height: 52,
        fontSize: 15,
        paddingLeft: '32px',
        paddingRight: '32px',
        // minWidth: '33px',
        // padding: '0 18px',
        // transition: 'all ease-in-out .3s',
        // '& svg': {
        //   transition: 'all ease-in-out .3s',
        // },

        // '&:not(:hover)': {
        //   fontSize: 0,
        //   '& svg': {
        //     marginRight: '0 !important',
        //   }
        // },

        '&:hover': {
          borderColor: darken(backgroundColor, 0.1),
          backgroundColor: darken(backgroundColor, 0.1),
          color
        }
      }}
    >
      {icon}{children}
    </Button>
  )
}